module.exports = __webpack_public_path__ + "static/img/yonghu1.96864d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/newChat/yonghu1.png
// module id = xrGV
// module chunks = 1